module.exports = __webpack_public_path__ + "img/dashboard.8bb1ce7e.svg";